<template>
    <div id="feedback">
        <ul class="links">
            <li><router-link to='/user/feedback/question'>问题反馈</router-link></li>
            <li><router-link to='/user/feedback/list?disposeState=1' replace>待处理</router-link></li>
            <li><router-link to='/user/feedback/list?disposeState=2' replace>已处理</router-link></li>
            <li><router-link to='/user/feedback/list' replace>全部问题</router-link></li>
        </ul>
        <div class="view">
            <router-view/>
        </div>
    </div>
</template>
<script>
import {getFeedbackList} from '@/api/user'
export default {
    methods: {
        
    },
    created(){
        
    }
}
</script>
<style lang="less">
#feedback {
    min-height: 100%;
    background: #f2f2f2;
    ul.links {
        display: flex;
        justify-content: space-around;
        background: #fff;
        li {
            width: 25%;
            line-height: 38px;
            text-align: center;
            a {
                display: inline-block;
                color: #838383;
                line-height: 28px;
                &.router-link-exact-active {
                    color: #2c3e50;
                    border-bottom: 2px solid #26a2ff;        
                }                 
            }                
        }
    }
    ul.questions {        
        li {
            margin-top: 10px;
            background: #fff;
        }
        .liHeader, .liFooter {
            display: flex;
            justify-content: space-between;
            padding: 0 3%;
            line-height: 36px;
        }
        .liMain {
            min-height:60px;
            padding: 6px 3%;
            line-height: 1.5em;
            border-top: 1px solid #f0f0f0;
            border-bottom: 1px solid #f0f0f0;
        }
        .liFooter button {
            margin-left: 10px;
        }
    }
    .view {
        height: calc(100% - 48px);
        padding-bottom: 10px;
    }
}
</style>

